import React from "react";
import "./index.css";

import Icon from "../Icon";

export default ({ icon, iconName, placeholder, hide, error, value, onChangeText, onBlur, disabled, type, autoFocus, autoComplete, inputMode, maxLength, name }) => {

    const resolvedType = type || (hide ? "password" : "text");

    return(
        <div className="text-input-with-icon-container" style={{borderColor: error ? "var(--jc-danger-600)" : ""}}>
            {iconName ? (
                <div className="text-input-icon-container">
                    <Icon name={iconName} size={20} />
                </div>
            ) : icon ? (
                <div className="text-input-icon-container">
                    <img src={icon} alt="" />
                </div>
            ) : null}
            <div className="text-input-with-icon-input-container">
                <input
                    value={value}
                    onChange={(e) => onChangeText(e.target.value)}
                    onBlur={onBlur}
                    required={true}
                    type={resolvedType}
                    className="text-input-with-icon-input"
                    disabled={disabled}
                    autoFocus={autoFocus}
                    autoComplete={autoComplete}
                    inputMode={inputMode}
                    maxLength={maxLength}
                    name={name}
                />
                <span className="text-input-with-icon-floating-placeholder">{placeholder}</span>
            </div>
            {error &&
                <div className="text-input-error-icon-container">
                    <Icon name="alert-circle" size={18} />
                </div>
            }
        </div>
    );

}
